<span *ngIf="withText">{{ text | translate }}</span>
<span class="dot dot1">.</span><span class="dot dot2">.</span
><span class="dot dot3">.</span>
